import { useRef } from "react";
import { authConfig } from "@/auth";
import config from "@/config";
import ApiProvider, { useOctraceClient } from "@/contexts/ApiClientContext";
import WebSocketProvider from "@/contexts/WebSocketContext";
import { router } from "@/router";
import { LogtoProvider, useLogto } from "@logto/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { PostHogProvider } from "posthog-js/react";
import { Toaster } from "react-hot-toast";

import useLogtoUser from "@/hooks/api/useLogtoUser";

// eslint-disable-next-line react-refresh/only-export-components
export const queryClient = new QueryClient();

const RouterApp = () => {
  const auth = useLogto();
  const authRef = useRef(auth);
  authRef.current = auth;

  const { apiClient } = useOctraceClient();
  const apiClientRef = useRef(apiClient);
  apiClientRef.current = apiClient;

  useLogtoUser();

  return (
    <WebSocketProvider>
      <PostHogProvider apiKey={config.POSTHOG_KEY} options={{ api_host: config.POSTHOG_HOST }}>
        <RouterProvider router={router} context={{ auth: authRef, apiClient: apiClientRef }} />
        <Toaster position="bottom-right" containerStyle={{ zIndex: 99 }} />
      </PostHogProvider>
    </WebSocketProvider>
  );
};

const InnerApp = () => {
  return (
    <ApiProvider>
      <RouterApp />
    </ApiProvider>
  );
};

const App = () => {
  return (
    <LogtoProvider config={authConfig}>
      <QueryClientProvider client={queryClient}>
        <InnerApp />
      </QueryClientProvider>
    </LogtoProvider>
  );
};

export default App;
